import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

  import useBreakpoint from '@/composables/useBreakpoint'
  import useCommonMixin from '@/composables/useCommonMixin'
  import { UserModule } from '@/store/modules/user'

  interface FooterLink {
    href: string
    text: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

  const { isSmallerMobileDevice } = useBreakpoint()
  const { inDevelopment } = useCommonMixin()

  const companyDomainName = computed(() => UserModule.company?.domainName)

  const footerLinks: FooterLink[] = [
    { href: 'https://www.sachkundegurus.de/impressum', text: 'Impressum' },
    { href: 'https://www.sachkundegurus.de/datenschutz', text: 'Datenschutz' },
    { href: 'https://www.sachkundegurus.de/agb', text: 'AGB' },
  ]

return { __sfc: true,isSmallerMobileDevice, inDevelopment, companyDomainName, footerLinks, computed, useBreakpoint, useCommonMixin, UserModule }
}

})